<template>
    <div class="category mb-5">
        <h3><span>{{category.title}}</span></h3>
        <DocumentList :documents="documents" :cols="4" :show-category="false"></DocumentList>
    </div>
</template>

<script>
    import DocumentTeaser from "./DocumentTeaser.vue";
    import DocumentList from "./DocumentList";

    export default {
        name: "Category",
        components: {DocumentList, DocumentTeaser},
        props: ['id'],
        computed: {
            category() {
                return this.$store.getters.categoryById(this.id)
            },

            documents() {
                return this.$store.getters.documentsByCategory(this.id);
            }
        }
    }
</script>

<style scoped lang="scss">

    h3 {
        font-size: 2.0rem;
        line-height: 2.4rem;
        font-weight: normal;
        margin-bottom: 2rem;

        span {
            background-color: #efefef;
            padding: 5px 8px;
            border-radius: 5px;
        }

    }
</style>